import gql from "graphql-tag";

export const GET_ALL_POST = gql`
  query posts(
    $profile_id: uuid
    $search_text: String = "%%"
    $status: [post_status_enum!]
  ) {
    posts(
      order_by: { publish_time: desc }
      where: {
        content: { _ilike: $search_text }
        _or: [
          { business_profile_id: { _eq: $profile_id } }
          { council_profile_id: { _eq: $profile_id } }
          { club_profile_id: { _eq: $profile_id } }
        ]
        status: { _in: $status }
      }
    ) {
      id
      content
      type
      status
      publish_time
      parse_body
      mobile_body
      content
      post_image_galleries {
        id
        image_path
        image_url
      }
      post_likes_aggregate {
        aggregate {
          count
        }
      }
      image_url
      image_path
    }
    posts_total: posts_aggregate(
      where: {
        content: { _ilike: $search_text }
        _or: [
          { business_profile_id: { _eq: $profile_id } }
          { council_profile_id: { _eq: $profile_id } }
          { club_profile_id: { _eq: $profile_id } }
        ]
        status: { _in: $status }
      }
    ) {
      aggregate {
        count
      }
    }
    post_published_total: posts_aggregate(
      where: {
        content: { _ilike: $search_text }
        _or: [
          { business_profile_id: { _eq: $profile_id } }
          { council_profile_id: { _eq: $profile_id } }
          { club_profile_id: { _eq: $profile_id } }
        ]
        status: { _in: [published, scheduled] }
      }
    ) {
      aggregate {
        count
      }
    }
    post_draft_total: posts_aggregate(
      where: {
        content: { _ilike: $search_text }
        _or: [
          { business_profile_id: { _eq: $profile_id } }
          { council_profile_id: { _eq: $profile_id } }
          { club_profile_id: { _eq: $profile_id } }
        ]
        status: { _in: [draft] }
      }
    ) {
      aggregate {
        count
      }
    }
  }
`;
